import { useCallback } from 'react';
import { pm2SitemapStore, findPageDescriptorById, shouldTerminateMegaMenu, getNestedPages } from '@pm2/sitemap-utils';
import { pm2ConfigStore, pm2InterfaceStore } from '@pm2/store';
import { useLocation } from '@provider/navigation';

/**
 * Navigates further into the MegaMenu, when clicking on an item inside the
 * MegaMenu layer.
 */
function useOnNavigate(closeMegaMenu) {
  const location = useLocation();
  const configStore = pm2ConfigStore.useStore();
  const sitemapStore = pm2SitemapStore.useStore();
  const sitemapState = pm2SitemapStore.useSelector(state => state);
  const megaMenu = pm2InterfaceStore.useSelector(state => state.megaMenu)?.map(id => findPageDescriptorById(sitemapState, id)).filter(it => it !== undefined);
  return useCallback(async (evt, navigateTo, replace) => {
    // There's no need to attempt to navigate further into the mega-menu if
    // the descriptor is a termination point.
    if (shouldTerminateMegaMenu(navigateTo)) {
      // ... however, in case we attempt to navigate to the page we're already
      // on, then simply close the megamenu in order to avoid confusion due
      // to nothing happening.
      if (evt.isPropagationStopped() || location.asPath === navigateTo.path) {
        closeMegaMenu();
      }
      return;
    }
    await getNestedPages(configStore, sitemapStore, navigateTo);
    if (replace) {
      // When navigating from the leftNav, then we're interested in replacing
      // the currently rendered descriptor inside the MegaMenuLayer instead
      // of adding a new layer.
      if (megaMenu) {
        pm2InterfaceStore.dispatch(pm2InterfaceStore.actions.replaceMegaMenuLayer(navigateTo.id));
      }
    } else {
      pm2InterfaceStore.dispatch(pm2InterfaceStore.actions.pushMegaMenuLayer(navigateTo.id));
    }
  }, [configStore, sitemapStore, location.asPath, closeMegaMenu, megaMenu]);
}

export { useOnNavigate };
//# sourceMappingURL=useOnNavigate.js.map
